/* Joystick theme: age gate, nav, P1/P2 toggle, class filter, flavor readout, forms, reveal.
   Ported from the concept site app.js. Storage keys: js_age (timestamp), js_mode (aio|cart). */
(function () {
  'use strict';
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : v; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var mode = store.get('js_mode', 'aio') === 'cart' ? 'cart' : 'aio';

  /* ---------- age gate ---------- */
  function gate() {
    var g = $('#gate');
    if (!g) return;
    if (/^\/policies\//.test(location.pathname)) { g.hidden = true; return; } /* legal pages stay readable from the gate links */
    if (window.Shopify && Shopify.designMode) {
      /* Theme editor: keep the gate out of the way; show it only while its section is selected. */
      g.hidden = true;
      var sec = g.closest('.shopify-section');
      document.addEventListener('shopify:section:select', function (e) { if (sec && e.target === sec) g.hidden = false; });
      document.addEventListener('shopify:section:deselect', function (e) { if (sec && e.target === sec) g.hidden = true; });
      return;
    }
    var days = parseInt(g.getAttribute('data-remember-days'), 10) || 30;
    var saved = store.get('js_age', '');
    var ts = saved === 'yes' ? Date.now() : parseInt(saved, 10);
    if (ts && Date.now() - ts < days * 86400000) { g.hidden = true; return; }
    g.hidden = false;
    document.body.style.overflow = 'hidden';
    var yes = $('#gate-yes');
    if (yes) yes.focus();
    yes.addEventListener('click', function () {
      store.set('js_age', String(Date.now()));
      g.hidden = true;
      document.body.style.overflow = '';
    });
    $('#gate-no').addEventListener('click', function () {
      $('.gate-no', g).textContent = g.getAttribute('data-game-over') || '';
    });
    g.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('button', g);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- nav ---------- */
  function nav() {
    var b = $('.menu-btn'), n = $('.nav');
    if (!b || !n) return;
    b.addEventListener('click', function () {
      var o = n.classList.toggle('open');
      b.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
  }

  /* ---------- P1 / P2 mode ---------- */
  function applyMode() {
    $$('.players .pill').forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-m') === mode ? 'true' : 'false'); });
    $$('.art-aio').forEach(function (i) { i.hidden = mode !== 'aio'; });
    $$('.art-cart').forEach(function (i) { i.hidden = mode !== 'cart'; });
    $$('.tile-in').forEach(function (t) { t.setAttribute('data-p', mode === 'cart' ? 'P2' : 'P1'); });
    $$('[data-status]').forEach(function (s) { s.hidden = s.getAttribute('data-status') !== mode; });
  }
  function players() {
    var pills = $$('.players .pill');
    if (!pills.length) return;
    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-m') === 'cart' ? 'cart' : 'aio';
        store.set('js_mode', mode);
        applyMode();
      });
    });
    applyMode();
  }

  /* ---------- flavor grid: readout + class filter ---------- */
  function readout() {
    var ro = $('#sel');
    if (!ro) return;
    var idleText = ro.getAttribute('data-idle') || '';
    var nowText = ro.getAttribute('data-now') || '';
    var arrow = '<span class="arrow"><svg class="ico" aria-hidden="true"><use href="#i-arrow"/></svg></span> ';
    function idle() { ro.style.removeProperty('--a'); ro.innerHTML = arrow; ro.appendChild(document.createTextNode(idleText)); var c = document.createElement('span'); c.className = 'cursor'; ro.appendChild(c); }
    function on(t) {
      ro.style.setProperty('--a', t.getAttribute('data-a') || '');
      ro.innerHTML = arrow;
      ro.appendChild(document.createTextNode(nowText + ' '));
      var b = document.createElement('b'); b.textContent = t.getAttribute('data-n'); ro.appendChild(b);
      var s = document.createElement('span'); s.textContent = ' ' + t.getAttribute('data-cls'); ro.appendChild(s);
    }
    idle();
    $$('#select .tile').forEach(function (t) {
      t.addEventListener('mouseenter', function () { on(t); });
      t.addEventListener('focus', function () { on(t); });
      t.addEventListener('mouseleave', idle);
      t.addEventListener('blur', idle);
    });
  }
  function classFilter() {
    var pills = $$('#fl-pills .pill');
    var grid = $('#select');
    if (!grid) return;
    var tiles = $$('.tile', grid);
    var countEl = $('#fl-count');
    var tpl = grid.getAttribute('data-count-text') || '';
    var current = 'all';
    function draw() {
      var shown = 0;
      tiles.forEach(function (t) {
        var match = current === 'all' || (t.getAttribute('data-cls') || '').toLowerCase() === current;
        t.hidden = !match;
        if (match) shown++;
      });
      pills.forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-f') === current ? 'true' : 'false'); });
      if (countEl) countEl.textContent = tpl.replace('[shown]', shown).replace('[total]', tiles.length);
    }
    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-f');
        try { history.replaceState(null, '', current === 'all' ? location.pathname : '?f=' + current); } catch (e) {}
        draw();
      });
    });
    var qf = (new URLSearchParams(location.search).get('f') || '').toLowerCase();
    if (['indica', 'sativa', 'hybrid'].indexOf(qf) > -1) current = qf;
    draw();
  }

  /* ---------- flavor detail ---------- */
  function flavorPage() {
    var el = $('[data-flavor]');
    if (!el) return;
    var btn = $('#notify-btn'), form = $('#notify-form');
    if (btn && form) {
      if (!$('.ok.on', form)) form.hidden = true;
      btn.addEventListener('click', function () {
        form.hidden = !form.hidden;
        btn.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
        if (!form.hidden) { var i = $('input[type=email]', form); if (i) i.focus(); }
      });
    }
    var prev = $('#prev'), next = $('#next');
    document.addEventListener('keydown', function (e) {
      if (/INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft' && prev) location.href = prev.href;
      if (e.key === 'ArrowRight' && next) location.href = next.href;
    });
  }

  /* ---------- forms ---------- */
  function forms() {
    /* ZIP is added to the customer tags: "drop-alerts, zip-07102" */
    $$('form').forEach(function (f) {
      var zip = $('input[name=zip]', f), tags = $('input[name="contact[tags]"]', f);
      if (!zip || !tags) return;
      f.addEventListener('submit', function () {
        var z = (zip.value || '').replace(/\D/g, '');
        if (z) tags.value = 'drop-alerts, zip-' + z;
      });
    });
    var rec = $('[data-recover]');
    if (rec) {
      var box = $('#recover');
      if (location.hash === '#recover' || (box && $('.ok.on', box))) box.hidden = false;
      rec.addEventListener('click', function (e) { e.preventDefault(); box.hidden = !box.hidden; });
    }
    var ok = $('.ok.on[data-focus-on-load]');
    if (ok) { ok.focus(); }
  }

  /* ---------- reveal ---------- */
  function reveal() {
    var els = $$('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init() { gate(); nav(); players(); readout(); classFilter(); flavorPage(); forms(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor: a section Cam adds or edits is re-rendered, so wake up its reveal animations,
     P1/P2 toggle and flavor grid instead of leaving cards invisible until a page reload. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    $$('.players .pill', root).forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-m') === 'cart' ? 'cart' : 'aio';
        store.set('js_mode', mode);
        applyMode();
      });
    });
    applyMode();
    if ($('#select', root)) { readout(); classFilter(); }
    $$('.rv', root).forEach(function (el) { el.classList.add('in'); });
  });
})();

/* ---------- signup popup ----------
   Opens on the first of: scroll depth (data-scroll %), or the visitor's Nth page view this session (data-views).
   Never while the 21+ gate is open. Dismissed: quiet for data-days. Submitted: never again.
   Storage keys: js_su_done (localStorage), js_su_dismiss (localStorage timestamp), js_pv (sessionStorage page-view count).
   data-mode="demo" shows the success state locally; "shopify" posts the real Shopify customer form. */
(function () {
  'use strict';
  var el = document.getElementById('su');
  if (!el) return;
  if (window.Shopify && window.Shopify.designMode) return; /* theme editor: never pop over the preview */
  if (/^\/policies\//.test(location.pathname)) return; /* legal pages stay readable */
  var card = el.querySelector('.su-card'), form = el.querySelector('form'), main = el.querySelector('.su-main'), ok = el.querySelector('.su-ok');
  var mode = el.getAttribute('data-mode') || 'demo';
  var PCT = parseFloat(el.getAttribute('data-scroll')) || 80;
  var VIEWS = parseInt(el.getAttribute('data-views'), 10) || 2;
  var DAYS = parseFloat(el.getAttribute('data-days')); if (isNaN(DAYS)) DAYS = 14;
  var gate = document.getElementById('gate');
  var shown = false, timer = 0, lastFocus = null, prevOverflow = '';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} return null; }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }

  var views = (parseInt(ss('js_pv'), 10) || 0) + 1;
  ss('js_pv', String(views));

  function eligible() {
    if (ls('js_su_done')) return false;
    var d = parseInt(ls('js_su_dismiss'), 10);
    return !(d && Date.now() - d < DAYS * 86400000);
  }
  function gateOpen() { return !!(gate && !gate.hidden); }
  function scrolled() {
    var de = document.documentElement, max = de.scrollHeight - window.innerHeight;
    if (max < 40) return false;
    return (window.pageYOffset || de.scrollTop) / max >= PCT / 100;
  }
  function evaluate() {
    if (shown || !eligible() || gateOpen()) return;
    if (scrolled()) { open(); return; }
    if (views >= VIEWS && !timer) {
      timer = setTimeout(function () { timer = 0; if (!shown && eligible() && !gateOpen()) open(); }, 1500);
    }
  }

  function focusables() {
    return Array.prototype.slice.call(card.querySelectorAll('button, a[href], input, select, textarea')).filter(function (n) {
      return !n.disabled && n.type !== 'hidden' && (n.offsetWidth || n.offsetHeight || n.getClientRects().length) && n.getAttribute('aria-hidden') !== 'true';
    });
  }
  function open(posted) {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    el.hidden = false;
    var target = posted ? ok : card;
    if (posted) card.setAttribute('aria-labelledby', 'su-ok-h');
    (target || card).setAttribute('tabindex', '-1');
    (target || card).focus();
    document.addEventListener('keydown', onKey, true);
  }
  function close(dismissed) {
    if (!shown) return;
    shown = false;
    el.hidden = true;
    document.body.style.overflow = gateOpen() ? 'hidden' : prevOverflow;
    document.removeEventListener('keydown', onKey, true);
    if (dismissed && !ls('js_su_done')) ls('js_su_dismiss', String(Date.now()));
    if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); card.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!card.contains(a) || a === card) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  Array.prototype.forEach.call(el.querySelectorAll('[data-su-close]'), function (b) { b.addEventListener('click', function () { close(true); }); });
  el.addEventListener('mousedown', function (e) { if (e.target === el) close(true); });

  /* ----- form ----- */
  function digits(v) { var d = String(v || '').replace(/\D/g, ''); if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); return d.slice(0, 10); }
  function fmt(d) { return d.length < 4 ? d : d.length < 7 ? '(' + d.slice(0, 3) + ') ' + d.slice(3) : '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6); }
  var fFirst, fLast, fEmail, fPhone, fAge;
  if (form) {
    fFirst = form.querySelector('[data-f="first"]'); fLast = form.querySelector('[data-f="last"]'); fEmail = form.querySelector('[data-f="email"]');
    fPhone = form.querySelector('[data-f="phone"]'); fAge = form.querySelector('[data-f="age"]');
    if (fPhone) fPhone.addEventListener('input', function () { var v = fmt(digits(fPhone.value)); if (v !== fPhone.value) fPhone.value = v; });
  }
  function setErr(input, msg) {
    var p = document.getElementById(input.getAttribute('aria-describedby'));
    if (p) p.textContent = msg || '';
    if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
  }
  function validate() {
    var bad = null;
    function chk(input, ok_, msg) { setErr(input, ok_ ? '' : msg); if (!ok_ && !bad) bad = input; }
    chk(fFirst, fFirst.value.trim().length > 0, 'Enter your first name.');
    if (fLast) chk(fLast, fLast.value.trim().length > 0, 'Enter your last name.');
    chk(fEmail, /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(fEmail.value.trim()), 'Enter a valid email address.');
    chk(fPhone, digits(fPhone.value).length === 10, 'Enter a 10 digit US phone number.');
    chk(fAge, fAge.checked, 'Check the box to continue.');
    if (bad) bad.focus();
    return !bad;
  }
  function showSuccess() {
    ls('js_su_done', '1');
    if (main) main.hidden = true;
    if (ok) { ok.classList.add('on'); ok.setAttribute('tabindex', '-1'); card.setAttribute('aria-labelledby', 'su-ok-h'); ok.focus(); }
  }
  if (form && mode === 'demo') {
    form.addEventListener('submit', function (e) { e.preventDefault(); if (validate()) showSuccess(); });
  } else if (form) {
    /* Shopify: validate on the button click so an invalid form never reaches the submit (or the forms backup mirror). */
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.addEventListener('click', function (e) {
      if (!validate()) { e.preventDefault(); return; }
      var d = '+1' + digits(fPhone.value);
      form.querySelector('[name="contact[phone]"]').value = d;
      form.querySelector('[name="contact[note]"]').value = 'Popup signup. Phone ' + d + '. Agreed to emails and texts on ' + new Date().toISOString().slice(0, 10) + '.';
    });
  }

  /* ----- start ----- */
  function start() {
    if (el.querySelector('[data-posted="true"]')) { ls('js_su_done', '1'); var go = function () { if (!gateOpen()) open(true); }; go(); if (!shown && gate && window.MutationObserver) { var po = new MutationObserver(function () { if (!shown && !gateOpen()) { open(true); po.disconnect(); } }); po.observe(gate, { attributes: true, attributeFilter: ['hidden'] }); } return; }
    if (el.querySelector('#su-server-errors')) { if (!gateOpen()) open(); }
    window.addEventListener('scroll', evaluate, { passive: true });
    window.addEventListener('resize', evaluate);
    if (gate && window.MutationObserver) new MutationObserver(evaluate).observe(gate, { attributes: true, attributeFilter: ['hidden'] });
    evaluate();
  }
  /* run after the page's own init so the age gate has already decided whether to show */
  function boot() { setTimeout(start, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
